import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { headersTables } from '@bl-constants/table-header.const';
import { StepperService } from '@core/stepper/stepper.service';
import { ActionPlanServices } from '@core/action-plan/action-plan.services';
import { GetAnalysisService } from '@core/analysis/get-analysis.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';

import { FormControl } from '@angular/forms';

import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

export class Operations {
  constructor(
    public value: string,
    public label: string,
    public id: string,
    public initDate: string,
    public endDate: string,
    public status: string,
    public projectName: string,
    public loanNumber: string,
  ) {}
}

@Component({
  selector: 'bid-action-plan',
  templateUrl: './action-plan.component.html',
  styleUrls: ['./action-plan.component.scss'],
})
export class ActionPlanComponent implements OnInit {
  STEP1 = [
    { name: 'loadActionPlan', stepSelected: true },
    { name: 'updateActionPlan', stepSelected: false, disabled: false },
    { name: 'myActionPlan', stepSelected: false, disabled: false },
  ];
  loanNumber: string;
  auditPeriodInit;
  auditPeriodEnd;
  projectName: string;
  titleActionPlan: string;
  status: string;

  countToImplements = 0;
  countInProgress = 0;
  countComplete = 0;

  getOperation;
  analysisData: any;
  headerTUAP: object;
  executingAgenciesOptions;
  isMyactionPlan = false;
  @Output() operationNumber = new EventEmitter();

  Operations_lis: Array<Operations> = [];
  constructor(
    private stepperService: StepperService,
    private actionPlanServives: ActionPlanServices,
    private analysisServices: GetAnalysisService,
    private spinner: NgxSpinnerService,
    private router: Router,
  ) {
    this.OperationsCtrl = new FormControl();
    this.filteredOperations = this.OperationsCtrl.valueChanges.pipe(
      startWith(''),
      map((Operation) => (Operation ? this.filterOperation(Operation || '') : this.Operations_lis)),
    );
  }

  ngOnInit() {
    const userRol = JSON.parse(localStorage.getItem('rolUserLocalStorage'));
    if (userRol) {
      if (userRol.rol == 'OE') this.titleActionPlan = 'Generate Action Plan';
      if (userRol.rol == 'FR') this.titleActionPlan = 'Approve Action Plan';
    }
    if (this.router.url == '/MyActionPlan') {
      this.titleActionPlan = 'My action Plan';
      this.isMyactionPlan = true;
    }
    this.headerTUAP = headersTables.headerActionPlanTable;

    this.stepperService.setStepper(this.STEP1);
    this.getOperation = '';
    this.getIdAnalisys();
  }

  getIdAnalisys() {
    this.spinner.show();

    this.actionPlanServives.getOperationNumber(this.isMyactionPlan).subscribe(
      (res: any) => {
        console.log('resOperationNUmber:', res);
        res.forEach((item: any, index) => {
          let OperationsObj = new Operations(
            item.idActionPlan,
            item.operationNumber + '-' + item.period,
            item.id,
            item.initDate,
            item.endDate,
            item.statusAP,
            item.projectName,
            item.operationNumber,
          );
          this.Operations_lis.push(OperationsObj);
        });
        this.spinner.hide();
      },
      (error) => {
        console.log('error:', error);
        this.spinner.hide();
      },
    );
  }

  changeOperation(event) {
    const seleccionado = this.Operations_lis.filter((s) => s.value == event.value);
    this.operationNumber.emit(event.value);
    this.getOperation = event;
    if (seleccionado.length > 0) {
      this.loanNumber = seleccionado[0].loanNumber;
      this.status = seleccionado[0].status;
      this.projectName = seleccionado[0].projectName;
      this.auditPeriodInit = seleccionado[0].initDate;
      this.auditPeriodEnd = seleccionado[0].endDate;
    }
  }

  getActionPlans(event) {
    this.countToImplements = 0;
    this.countInProgress = 0;
    this.countComplete = 0;
    if (event._data.value) {
      event._data.value.map((item) => {
        if (item.status == 'To implement') this.countToImplements += 1;
        if (item.status == 'In progress') this.countInProgress += 1;
        if (item.status == 'Completed') this.countComplete += 1;
      });
    }
  }

  length: number;
  OperationsCtrl: FormControl;
  filteredOperations: Observable<any[]>;
  filterOperation(name: string) {
    let arr = this.Operations_lis.filter((option) =>
      option.label.toLowerCase().includes(name.toLowerCase()),
    );
    return arr.length ? arr : [{ name: 'No Item found', code: 'null' }];
  }
}
